import styled from 'styled-components';
import { mediumBreakpoint } from 'utilities/constants';

export const SplitBox = styled.div`
  width: calc(33.33333% + 2rem);
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  padding: 0 0 0 6rem;

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    margin-left: calc(-3rem - 0.5px);
    border-left: solid 1px #f1f1f1;
    top: 0;
    height: 100%;
  }

  @media (max-width: ${mediumBreakpoint}px) {
    width: 100%;
    min-height: 100%;
    text-align: inherit;
    padding: 0;
  }

  &:first-child {
    border-top-left-radius: inherit;
    margin-left: -6rem;

    @media (max-width: ${mediumBreakpoint}px) {
      border-top-left-radius: inherit;
      margin-left: 0;
    }

    hr {
      margin-top: 0;
    }
  }

  hr {
    display: block;
    margin-bottom: 1.75rem;
    margin-top: 0;
    text-align: left;
    width: 100%;
    position: relative;
    padding: 0;
    border: 0;

    @media (max-width: ${mediumBreakpoint}px) {
      margin-top: 2rem;
    }

    &:before {
      content: '';
      width: 2rem;
      display: inline-block;
      vertical-align: middle;
      border-top: solid 2px #5089c5;
      max-width: 100%;
    }
  }
`;
